/* eslint-disable prettier/prettier */
import { mapMutations, mapState } from 'vuex';

export default {
  methods: {
    ...mapMutations([
      'setUtmParams',
      'setToken',
      'setUser',
      'setPatientId',
      'setDeliveryAddress',
    ]),
  },

  mounted() {
    // if (!this.token) {
    const token = this.$cookies.get('x-lev-token');
    if (token) {
      this.setToken(token);
      this.$bolev
        .user()
        .then((res) => {
          this.$cookies.remove('x-lev-token');
          if (res.data) {
            this.setUser(res.data);
            this.setPatientId(res.data.patientId);
            this.setDeliveryAddress(res.data.deliveryAddress);
          } else {
            this.setToken(null);
          }
        })
        .catch(() => {
          this.setToken(null);
        });
    }
    // }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const utmParams = Object.keys(params)
      .filter((k) => k.startsWith('utm_'))
      .reduce((previous, current) => {
        previous[current.replace(/utm_/, '')] = params[current];
        return previous;
      }, {});
    if (Object.keys(utmParams).length) {
      this.setUtmParams(utmParams);
    }
  },

  computed: {
    isPortuguese() {
      return process.env.LOCALE === 'pt_PT';
    },
    isSpanish() {
      return process.env.LANG === 'es';
    },
    isFrench() {
      return process.env.LANG === 'fr';
    },
    isAngola() {
      return process.env.LOCALE === 'pt_AO';
    },
    ...mapState({
      token: (state) => state.token,
    }),
  },
};
